module.exports = __webpack_public_path__ + "assets/img/logo-lead.ee47eb1f.svg";